import React, { useState } from 'react'
import { Checkbox, FormControlLabel, Button, Container } from '@material-ui/core'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { Link } from 'react-router-dom'
import history from './../../../Component/ShearCompo/carateBrowserHistory.js'
import { Row } from 'react-bootstrap';

const JwtRegister = () => {
    document.title = "Register";

    const [state, setState] = useState({})
    const handleChange = ({ target: { name, value } }) => {
        setState({
            ...state,
            [name]: value,
        })
    }
    const handleFormSubmit = (event) => {
        try {
            // register(state.email, state.username, state.password)
            history.push('/')
        } catch (e) {
            console.log(e)
        }
    }

    let { username, email, password, agreement } = state

    return (
        <Container >
            <Row>
                <div className="col-md-4 px-4 d-flex">
                    <img
                        className="w-200"
                        src="https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/shopkpr-personal/logo/logo_1.svg"
                        alt=""
                    />
                </div>
                <div className="col-md-6">
                    <h4 className="pb-3">Enter Registration Details</h4>
                    <ValidatorForm onSubmit={handleFormSubmit}>
                        <TextValidator
                            className="w-100 mb-3"
                            variant="outlined"
                            size="small"
                            label="Username"
                            onChange={handleChange}
                            type="text"
                            name="username"
                            value={username || ''}
                            validators={['required']}
                            errorMessages={['this field is required']}
                        />
                        <TextValidator
                            className="w-100 mb-3"
                            variant="outlined"
                            size="small"
                            label="Email"
                            onChange={handleChange}
                            type="email"
                            name="email"
                            value={email || ''}
                            validators={['required', 'isEmail']}
                            errorMessages={[
                                'this field is required',
                                'email is not valid',
                            ]}
                        />
                        <TextValidator
                            className="w-100 mb-3"
                            label="Password"
                            variant="outlined"
                            size="small"
                            onChange={handleChange}
                            name="password"
                            type="password"
                            value={password || ''}
                            validators={['required']}
                            errorMessages={['this field is required']}
                        />
                        <FormControlLabel
                            className="w-100 mb-3"
                            name="agreement"
                            onChange={(e) =>
                                handleChange({
                                    target: {
                                        name: 'agreement',
                                        value: e.target.checked,
                                    },
                                })
                            }
                            control={
                                <Checkbox
                                    size="small"
                                    checked={agreement || false}
                                />
                            }
                            label="I have read and agree to the terms of service."
                        />
                        <div className="flex items-center">
                            <button className="capitalize btn btn-success px-5" type="submit">
                                Sign up
                            </button>
                            <span className="mx-2 ml-5">or</span>
                            <Link to="/session/login">
                                <Button className="capitalize text-primary text-decoration-underline">
                                    Login
                                </Button>
                            </Link>
                        </div>
                    </ValidatorForm>
                </div>
            </Row>
        </Container>
    )
}

export default JwtRegister
